<template>
  <section class="container-fluid founders-section py-5 bg-light" data-aos="fade-up" data-aos-duration="1200">
    <div class="container">
      <div class="row justify-content-center align-items-start">
        <!-- Columna izquierda: titular, nombre, marca de agua -->
        <div class="col-lg-6 col-12 d-flex flex-column align-items-center align-items-lg-start position-relative pb-5">
          <div class="w-100 text-lg-start text-center mb-1">
            <div class="founders-title mb-1">{{ titles[selectedLang] }}</div>
            <!-- Animación para nombre gigante -->
            <transition :name="transitionName" mode="out-in">
              <div :key="activeFounder.name[selectedLang]" class="founder-name-giant mb-2">{{ activeFounder.name[selectedLang] }}</div>
            </transition>
          </div>
          <!-- Imagen de fondo (marca de agua cuadrada) -->
          <div class="founder-bg-wrapper position-relative mt-2 mb-4">
            <!-- Animación para imagen de fondo -->
            <transition :name="transitionName" mode="out-in">
              <img
                :key="activeFounder.image"
                class="founder-bg-main "
                :src="activeFounder.image"
                :alt="activeFounder.name[selectedLang]"
                draggable="false"
              />
            </transition>
          </div>
        </div>
        <!-- Columna derecha: Card -->
        <div class="col-lg-6 col-12 d-flex justify-content-center align-items-start">
          <div class="founder-card card p-4 mt-4 mt-lg-0">
            <div class="d-flex align-items-start mb-2">
              <!-- Animación para imagen card -->
              <transition :name="transitionName" mode="out-in">
                <img
                  :key="activeFounder.image + '-card'"
                  :src="activeFounder.image"
                  class="founder-card-img me-3"
                  width="62"
                  height="62"
                  :alt="activeFounder.name[selectedLang]"
                />
              </transition>
              <div>
                <!-- Animación para texto card -->
                <transition :name="transitionName" mode="out-in">
                  <div :key="activeFounder.name[selectedLang] + '-card'">
                    <div class="fw-bold card-name text-monospace">
                      {{ activeFounder.name[selectedLang] }}
                    </div>
                    <div class="card-role small mb-1">
                      {{ activeFounder.position[selectedLang] }}
                    </div>
                    <div class="card-points mb-1">
                      <span
                        v-for="n in founders.length"
                        :key="n"
                        class="dot mx-1"
                        :class="{ filled: currentIdx === n - 1 }"
                      ></span>
                    </div>
                  </div>
                </transition>
              </div>
            </div>
            <!-- Animación para descripción -->
            <transition :name="transitionName" mode="out-in">
              <div :key="activeFounder.description[selectedLang]" class="card-desc small mb-4" v-html="activeFounder.description[selectedLang]"></div>
            </transition>
            <!-- Flechas centradas horizontalmente en la card -->
            <div class="d-flex justify-content-center gap-3">
              <button class="btn btn-outline-dark rounded-circle px-3 py-1" @click="prevFounder" aria-label="Anterior">
                <span>&#8592;</span>
              </button>
              <button class="btn btn-outline-dark rounded-circle px-3 py-1" @click="nextFounder" aria-label="Siguiente">
                <span>&#8594;</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { founders } from '@/assets/data/data.ts'
import AOS from 'aos'
import 'aos/dist/aos.css'

export default {
  name: 'FoundersSlides',
  props: {
    selectedLang: {
      type: String,
      default: 'es'
    }
  },
  data() {
    return {
      founders,
      titles: {
        es: "Nuestros Fundadores",
        en: "Our Founders",
        de: "Unsere Gründer"
      },
      currentIdx: 0,
      direction: 1 // 1 = next, -1 = prev
    }
  },
  computed: {
    activeFounder() {
      return this.founders[this.currentIdx];
    },
    transitionName() {
      return this.direction === 1 ? 'fade-slide-next' : 'fade-slide-prev';
    }
  },
  methods: {
    goTo(idx) {
      this.currentIdx = idx;
    },
    nextFounder() {
      this.direction = 1;
      this.currentIdx = (this.currentIdx + 1) % this.founders.length;
    },
    prevFounder() {
      this.direction = -1;
      this.currentIdx = (this.currentIdx - 1 + this.founders.length) % this.founders.length;
    }
  },
  mounted() {
    AOS.init({
      duration: 800,
      once: true
    });
    setTimeout(() => AOS.refresh(), 300);
  }
}
</script>

<style scoped>
.founders-section {
  background: #f5faf9;
  min-height: 550px;
  overflow-x: hidden;
  position: relative;
}

.founders-title {
  font-family: 'Caveat-Bold', cursive;
  font-size: 2.1rem;
  color: #1a2a2a;
  font-weight: 400;
  transition: color 0.3s ease;
  position: relative;
  display: inline-block;
  
}

.founders-title::after{
  content: '';
  position: absolute;
  left: 0;
  bottom: 0;
  height: 2px;
  width: 0%;
  background-color: currentColor;
  transition: width 0.3s ease;
}
.founders-title:hover::after{
  width: 100%;
}

.founder-name-giant {
  font-size: 2.2rem;
  color: #222;
  letter-spacing: 2px;
  font-weight: 300;
  margin-bottom: 1rem;
}

.founder-bg-wrapper {
  position: relative;
  width: 400px;
  height: 400px;
  max-width: 90vw;
  max-height: 90vw;
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}
.founder-bg-main {
  width: 100%;
  height: 100%;
  object-fit: cover;
  opacity: 0.13;
  filter: grayscale(1);
  background: #fff;
  border: 2px solid #bfc7ce;
  box-shadow: 0 2px 10px #0001;
  border-radius: 0;
  z-index: 1;
  position: relative;
  user-select: none;
  aspect-ratio: 1 / 1;
  transition: transform 0.4s ease, box-shadow 0.4s ease, filter 0.4s ease, opacity 0.4s ease;
}

.founder-bg-main:hover {
  transform: scale(1.1);
  box-shadow: 0 12px 24px rgba(0, 0, 0, 0.3);
  filter: grayscale(0);
  opacity: 0.6;
  cursor: pointer;
}

.founder-card {
  border: 2px solid #222;
  border-radius: 0;
  min-width: 290px;
  background: #fff;
  box-shadow: 0 2px 8px #0001;
  min-height: 320px;
  text-align: justify;
}
.founder-card-img {
  width: 62px;
  height: 62px;
  object-fit: cover;
  border: 2px solid #222;
  background: #f3f3f3;
  border-radius: 0;
  aspect-ratio: 1 / 1;
  transition: transform 0.4s ease, box-shadow 0.4s ease, filter 0.4s ease, opacity 0.4s ease;
}
.founder-card-img:hover {
  transform: scale(1.05);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.3);
  cursor: pointer;
}
.card-name {
  font-size: 1.1rem;
}
.card-role {
  font-size: 1rem;
  color: #116687;
  margin-bottom: 0.25rem;
}
.card-points .dot {
  display: inline-block;
  width: 10px;
  height: 10px;
  background: #333;
  border-radius: 50%;
  opacity: 0.18;
  transition: opacity 0.2s;
  transition: transform 0.3s ease, filter 0.3s ease;
}
.card-points .dot:hover{
    transform: scale(1.2); 
  filter: brightness(1.5); 
  cursor: pointer;
}
.card-points .dot.filled {
  opacity: 1;
  background: #116687;
}
.card-desc {
  font-size: 0.97rem;
  color: #222;
}

/* Animaciones fade + slide */
.fade-slide-next-enter-active,
.fade-slide-next-leave-active,
.fade-slide-prev-enter-active,
.fade-slide-prev-leave-active {
  transition: all 0.4s ease;
}
.fade-slide-next-enter-from {
  opacity: 0;
  width: 100%;
  transform: translateX(20px);
}
.fade-slide-next-leave-to {
  opacity: 0;
  width: 100%;
  transform: translateX(-20px);
}

/* Retroceder */
.fade-slide-prev-enter-active,
.fade-slide-prev-leave-active {
  transition: all 0.4s ease;
}
.fade-slide-prev-enter-from {
  opacity: 0;
  transform: translateX(-20px);
}
.fade-slide-prev-leave-to {
  opacity: 0;
  transform: translateX(20px);
}

/* Responsive */
@media (max-width: 991.98px) {
  .founder-bg-wrapper {
    width: 180px;
    height: 180px;
  }
  .founder-name-giant { font-size: 1.5rem; }
}
@media (max-width: 767.98px) {
  .founder-bg-wrapper {
    width: 160px;
    height: 160px;
  }
  .founder-bg-main {
    opacity: 0.35;
    filter: grayscale(0.2);
  }
  .founders-title { font-size: 1.2rem; }
  .founder-name-giant { font-size: 1rem; }
  .founder-card { padding: 1rem !important; }
  .founder-card-img { width: 40px; height: 40px; }
}
</style>
